import { render, staticRenderFns } from "./schoolList.vue?vue&type=template&id=eed1a30a"
import script from "./schoolList.vue?vue&type=script&lang=js"
export * from "./schoolList.vue?vue&type=script&lang=js"
import style0 from "./schoolList.vue?vue&type=style&index=0&id=eed1a30a&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports